/**
 * Ícones da chamada de vídeo (`AgoraVideoContainer` e os componentes dentro dele: controles,
 * chat, fundo virtual e card do participante). Exceção ao padrão `IconPaths` (traço Lucide) do
 * resto do sistema: aqui ficam os glifos sólidos do Font Awesome, mais legíveis sobre o vídeo.
 * Use como classe de um `<i>`: `<i className={VideoCallIcon.Mic} />`.
 */
export enum VideoCallIcon {
  Mic = 'fas fa-microphone',
  MicOff = 'fas fa-microphone-slash',
  Video = 'fas fa-video',
  VideoOff = 'fas fa-video-slash',
  VolumeMute = 'fas fa-volume-mute',
  VolumeLow = 'fas fa-volume-down',
  VolumeHigh = 'fas fa-volume-up',
  VirtualBackground = 'fas fa-image',
  ScreenShare = 'fas fa-desktop',
  Stop = 'fas fa-stop-circle',
  Maximize = 'fas fa-expand',
  Minimize = 'fas fa-compress',
  PictureInPicture = 'fas fa-up-right-from-square',
  Record = 'fas fa-record-vinyl',
  // Ponto do selo "Gravando"
  RecordingDot = 'fas fa-circle',
  Captions = 'fas fa-closed-captioning',
  Chat = 'fas fa-comment',
  ChatOff = 'fas fa-comment-slash',
  Chats = 'fas fa-comments',
  Send = 'fas fa-paper-plane',
  Close = 'fas fa-times',
  Remove = 'fas fa-times-circle',
  Check = 'fas fa-check',
  Blur = 'fas fa-adjust',
  Paint = 'fas fa-paint-brush',
  Add = 'fas fa-plus-circle',
  Upload = 'fas fa-cloud-upload-alt',
  Preview = 'fas fa-eye',
  Images = 'fas fa-images',
  Trash = 'fas fa-trash',
  Spinner = 'fas fa-spinner',
}
